<template>
  <div class="my-nav-def">
      <b-container >
          <b-row >
              <b-col class="d-flex align-items-center justify-content-between">
                  <div class="d-flex ">
                      <h4 class="m-0 p-0 my-logo text-white" @click="$router.push('/')"> {{ $t('onlinecalc') }} </h4>
                      <ul class="d-flex align-items-center ul-menu-class mb-0">
                          <li>
                              <a @click="$router.push({ name: 'getsalaryinfo' })"> {{ $t('twomenu') }} </a>
                          </li>
                      </ul>
                  </div>
                  
                  <div class="d-flex">
                        <!-- <h6 class="text-white telnomer m-0 p-0  d-flex align-items-center"> <div class="tel-icon d-flex align-items-center justify-content-center mr-2"> <b-icon icon="telephone" scale="0.8"></b-icon> </div> +998 71 241 01 86 </h6> -->
                        <b-dropdown  id="dropdown-1" :text="$t('lang')" class="m-md-2 capit">
                            <b-dropdown-item  @click="ChangeLang('ru')" :active="lang == 'ru'"> Русский язык </b-dropdown-item>
                            <b-dropdown-item  @click="ChangeLang('uz_cyrl')" :active="lang == 'uz_cyrl'"> Ўзбек тили </b-dropdown-item>
                            <b-dropdown-item  @click="ChangeLang('uz_latn')" :active="lang == 'uz_latn'"> O'zbek tili </b-dropdown-item>
                        </b-dropdown>
                  </div>
              </b-col>
          </b-row>
      </b-container>
  </div>
</template>

<script>
export default {
    data(){
        return{
            lang : localStorage.getItem('lang') || 'uz_cyrl'
        }
    },
    methods:{
        ChangeLang(item){
            localStorage.setItem('lang',item)
            window.location.reload()
        }
    }
}
</script>

<style>
.my-nav-def{
    height: 60px;
    background-color: rgba(45, 63, 163,0.9) !important;
}
.my-nav-def .row .col{
    height: 60px;
}
.tel-icon{
    border: 2px solid;
    width: 30px;
    height: 30px;
    border-radius: 50%;
}
.capit button{
    text-transform: capitalize;
    border:1px solid #fff;
    background-color: inherit;
    color: white;
}
.ul-menu-class{
    list-style-type: none;
   
}
.ul-menu-class li a {
     color: white !important;
     cursor: pointer;
     font-size: 18px;
}
</style>